import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { Annuncio } from 'src/app/models/annuncio';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { AnnuncioService } from 'src/app/services/annuncio.service';
import { EditAnnuncioComponent } from './dialogs/edit/edit.component';
import { AnnuncioAllegatiDialogComponent } from './dialogs/allegati/annuncio-allegati.component';

@Component({
  selector: 'annunci',
  templateUrl: './annunci.component.html',
  styleUrls: ['./annunci.component.scss']
})
export class AnnunciComponent implements OnInit {

  headingText = 'Annunci';

  relations: string[] = ['allegati'];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode = false;

  loading = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition({
      humanName: 'Titolo',
      internalName: 'titolo',
    }),
    new dataTableColumnDefinition({
      humanName: 'Contenuto',
      internalName: 'contenuto',
      displayFunction: (model) => model['contenuto']?.substring(0, 50),
    }),
    new dataTableColumnDefinition({
      humanName: 'Data creazione',
      internalName: 'created_at',
      displayFunction: (model: Annuncio) => model.created_at ? model.created_at.format('DD/MM/YYYY HH:mm') : '',
    }),
    new dataTableColumnDefinition({
      humanName: 'Allegati',
      internalName: 'attach_file',
      type: 'button',
      sortDisabled: true,
      onClick: (model: Annuncio) => this.manageAllegati(model),
      displayFunction: () => '',
    }),
  ];

  form: FormGroup;

  constructor(
    public annuncioService: AnnuncioService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<AnnunciComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
  ) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona un annuncio';
    }
  }

  ngOnInit() {
    this.form = this.fb.group({
      titolo: [],
    });

    this.form.valueChanges.subscribe(newValues => this.search = newValues);
  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model: Annuncio) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }

  deleteFunction = async (annuncio: Annuncio) => {
    try {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        data: { message: `Sei sicuro di voler eliminare l'annuncio ${annuncio.humanIdentifier}?` }
      });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.annuncioService.delete(annuncio);
          this.toast.success('Annuncio eliminato.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error('Eliminazione annuncio fallita.', 'Errore!');
    }
  }

  editFunction = async (annuncio: Annuncio) => {
    try {
      const dialogRef = this.dialog.open(EditAnnuncioComponent, { data: annuncio });
      dialogRef.afterClosed().subscribe(async (data: Annuncio) => {
        if (data) {
          Object.assign(annuncio, data);
          await this.annuncioService.edit(annuncio);
          this.toast.success('Annuncio modificato');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error('Modifica annuncio fallita.', 'Errore!');
    }
  }

  add() {
    const addDialogRef = this.dialog.open(EditAnnuncioComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(annuncio?: Annuncio) {
    if (annuncio) {
      try {
        await this.annuncioService.create(annuncio);
        this.toast.success('Annuncio creato!');
      } catch (e) {
        this.toast.error('Creazione annuncio fallita.', 'Errore!');
      } finally {
        this.updateDataSource();
      }
    }
  }

  manageAllegati(annuncio: Annuncio) {
    if (!annuncio?.id) {
      return;
    }

    this.dialog.open(AnnuncioAllegatiDialogComponent, {
      width: '600px',
      data: { annuncio }
    });
  }
}
